import React from 'react';
import { motion } from 'framer-motion';
import { Users, Crown, Video, Heart, Globe, ArrowRight } from 'lucide-react';
const services = [{
  icon: Users,
  title: 'In-Person Coaching',
  description: 'Face-to-face deep work in Tucson, AZ. No screens, no distractions — just real conversation and breakthrough.',
  detail: '60-min sessions'
}, {
  icon: Crown,
  title: 'VIP Intensive',
  description: 'An immersive, full-day coaching experience for men ready to go all-in on transformation.',
  detail: 'Full-day intensive'
}, {
  icon: Video,
  title: 'Virtual Coaching',
  description: 'High-impact coaching from anywhere in the world. Same depth, same fire — just through a screen.',
  detail: '60-min virtual sessions'
}, {
  icon: Heart,
  title: 'Life Coaching In Person',
  description: 'Holistic life coaching addressing relationships, purpose, faith, and emotional health — in person in Tucson.',
  detail: 'Ongoing program'
}, {
  icon: Globe,
  title: 'Life Coaching Virtual',
  description: "Comprehensive life coaching for men who want transformation but can't make it to Arizona.",
  detail: 'Ongoing virtual program'
}];
export function Services() {
  return <section id="services" className="py-24 bg-charcoal" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-144">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-145">
          <h2 className="font-heading text-4xl md:text-5xl text-white mb-4" data-id="element-146">
            Services
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-147"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-148">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group bg-dark p-8 border border-dark-lighter hover:border-gold transition-all duration-300 flex flex-col" data-id="element-149">
              <div className="mb-6" data-id="element-150">
                <service.icon className="text-gold w-8 h-8" data-id="element-151" />
              </div>

              <h3 className="font-heading text-2xl text-white mb-3" data-id="element-152">
                {service.title}
              </h3>

              <p className="text-gray-400 mb-6 flex-grow text-sm leading-relaxed" data-id="element-153">
                {service.description}
              </p>

              <div className="pt-6 border-t border-dark-lighter flex items-center justify-between" data-id="element-154">
                <span className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-155">
                  {service.detail}
                </span>
                <a href="#contact" className="text-gold hover:text-white flex items-center text-sm font-bold uppercase tracking-wide transition-colors" data-id="element-156">
                  Learn More <ArrowRight size={16} className="ml-2" data-id="element-157" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}